<template>
  <div class="num-filter-container">
    <div class="group-picker-content">
      <el-select :style="{ width: '100%' }" v-model="value.type">
        <el-option label="间隔分组" value="auto" />
        <el-option label="自定义分组" value="custom" />
        <el-option label="不分组" value="noRange" />
      </el-select>
    </div>

    <div class="container">
      <template v-if="value.type === 'auto'">
        <el-radio-group class="auto-container" v-model="radioType" @change="changeRadioHandle">
          <div class="auto-item">
            <el-radio label="ten">每间隔10进行分组</el-radio>
          </div>
          <div class="auto-item">
            <el-radio label="fifty">每间隔50进行分组</el-radio>
          </div>
          <div class="auto-item">
            <el-radio label="hundred">每间隔100进行分组</el-radio>
          </div>
          <div class="auto-item">
            <el-radio label="custom">
              <span>每间隔</span>
              <el-input-number
                class="num-input"
                :style="{ margin: '0 5px' }"
                :disabled="radioType !== 'custom'"
                v-model="value.valueSplit"
                :precision="0"
                size="small"
                :controls="false"
                :min="0"
              />
              <span>进行分组</span>
            </el-radio>
          </div>
        </el-radio-group>
      </template>

      <template v-if="value.type === 'custom'">
        <div class="custom-container">
          <div class="custom-item" v-for="(item, index) in value.valueArr" :key="index">
            <el-input-number
              class="num-input"
              v-model="item[0]"
              :precision="0"
              size="small"
              :controls="false"
              :min="0"
            />
            <el-tooltip content="点击切换" placement="top" effect="light">
              <div class="eq-tool-content" @click="value.fromEq = !value.fromEq">
                <span>{{ value.fromEq ? '≦' : '＜' }}</span>
              </div>
            </el-tooltip>
            <span>区间值</span>
            <el-tooltip content="点击切换" placement="top" effect="light">
              <div class="eq-tool-content" @click="value.toEq = !value.toEq">
                <span>{{ value.toEq ? '≦' : '＜' }}</span>
              </div>
            </el-tooltip>
            <el-input-number
              class="num-input"
              v-model="item[1]"
              :precision="0"
              size="small"
              :controls="false"
              :min="0"
            />
            <i class="el-icon-close close-icon" v-if="isRow" @click="delRangeHandle(index)"></i>
          </div>
          <div class="add-btn" v-show="showAddBtn" @click="addRangeHandle">
            <i class="el-icon-plus add-icon"></i>
            <span>添加区间</span>
          </div>
        </div>
      </template>

      <template v-if="value.type === 'noRange'">
        <div :style="{ margin: '15px 0 30px' }">
          <div class="auto-item">
            <el-radio value="check" label="check">没有区间</el-radio>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radioType: 'ten',
      value: {
        type: 'auto',
        valueArr: [[0, 10]],
        valueSplit: 10,
        fromEq: true,
        toEq: false
      }
    };
  },
  props: {
    fieldItem: {
      type: Object,
      required: true
    }
    // isRow: {
    //   type: Boolean,
    //   default: false
    // }
  },
  computed: {
    // 数额开放为分组
    isRow() {
      return true;
    },
    showAddBtn() {
      if (this.isRow) {
        return true;
      }
      return this.value.valueArr.length < 1;
    }
  },
  created() {
    let valueOfFilter = this.fieldItem.valueOfFilter;
    if (valueOfFilter) {
      valueOfFilter = JSON.parse(valueOfFilter);
    }
    if (valueOfFilter) {
      const func = val => {
        if (val === null) {
          return undefined;
        }
        return val;
      };
      const valueArr = (valueOfFilter.valueArr || []).map(val => {
        return [func(val[0]), func(val[1])];
      });
      this.value = { ...this.value, ...valueOfFilter, valueArr };
      if (this.value.valueSplit === 10) {
        this.radioType = 'ten';
      } else if (this.value.valueSplit === 50) {
        this.radioType = 'fifty';
      } else if (this.value.valueSplit === 100) {
        this.radioType = 'hundred';
      } else {
        this.radioType = 'custom';
      }
      if (!this.isRow) {
        this.value.type = 'custom';
        if (this.value.valueArr.length > 1) {
          this.value.valueArr = this.value.valueArr.slice(0, 1);
        }
      }
    } else {
      this.value.type = this.isRow ? 'auto' : 'custom';
    }
  },
  methods: {
    delRangeHandle(index) {
      this.value.valueArr.splice(index, 1);
    },
    addRangeHandle() {
      this.value.valueArr.push([]);
    },
    validateInfo() {
      const { type, valueArr, valueSplit } = this.value;
      if (type === 'custom') {
        if (valueArr.length < 1) {
          throw new Error('请添加分组区间');
        }
      } else {
        if (!valueSplit) {
          throw new Error('请输入正常间隔值');
        }
      }
      return this.value;
    },
    changeRadioHandle(val) {
      if (val === 'ten') {
        this.value.valueSplit = 10;
      } else if (val === 'fifty') {
        this.value.valueSplit = 50;
      } else if (val === 'hundred') {
        this.value.valueSplit = 100;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.num-filter-container {
  padding: 0 12px;

  .group-picker-content {
    display: flex;
    align-items: center;
    margin: 15px 0 0;
  }
  .container {
    width: 280px;
    max-height: 300px;
    overflow: auto;
    padding-bottom: 14px;

    .auto-container {
      .auto-item {
        margin: 15px 0 10px;
      }
    }

    .num-input {
      width: 70px;
    }

    .eq-tool-content {
      width: 24px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #1991fb;
      font-size: 12px;
      background-color: #eaf6ff;
      margin: 2px 5px;
      cursor: pointer;
    }

    .custom-container {
      margin-top: 10px;
      .custom-item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 10px 0;

        &:first-child {
          margin-top: 0;
        }

        .range-type-tip {
          color: #3d465a;
        }

        .close-icon {
          font-size: 16px;
          padding: 2px;
          cursor: pointer;
        }
      }

      .add-btn {
        box-sizing: border-box;
        width: 100%;
        color: rgba(#3d465a, 0.8);
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        border: 1px solid rgba(#3d465a, 0.2);
        cursor: pointer;

        .add-icon {
          font-size: 14px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
